import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DoneFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M12 2.53a9.47 9.47 0 1 0 0 18.94 9.47 9.47 0 0 0 0-18.94Zm4.16 7.5-5.25 5.25c-.16.16-.39.26-.62.26-.23 0-.46-.09-.62-.26L7.4 13.01a.881.881 0 0 1 0-1.24c.34-.34.9-.34 1.24 0l1.65 1.65 4.63-4.63c.34-.34.9-.34 1.24 0 .34.34.34.9 0 1.24Z"
      fill={color}
    />
  </Svg>
)

export default DoneFilled
